import { Typography, TypographyProps } from '@mui/material';
import { FC, ReactNode } from 'react';

export interface TextDisplayProps {
  label?: string;
  value?: ReactNode;
  captionProps?: TypographyProps;
  displayProps?: TypographyProps;
}

export const TextDisplay: FC<TextDisplayProps> = ({
  label,
  value,
  captionProps = {},
  displayProps = {},
}) => (
  <Typography
    variant="caption"
    {...captionProps}
    sx={[
      {
        color: 'text.secondary',
      },
      ...(Array.isArray(captionProps.sx) ? captionProps.sx : [captionProps.sx]),
    ]}
  >
    {label}
    <Typography
      {...displayProps}
      sx={[
        {
          color: 'text.primary',
          wordWrap: 'break-word',
          whiteSpace: 'pre-line',
        },
        ...(Array.isArray(displayProps.sx) ? displayProps.sx : [displayProps.sx]),
      ]}
    >
      {value}
    </Typography>
  </Typography>
);
